import * as React from "react";
import { Form, Input } from "antd";
import { RuleGroupFormFields } from "../../../common/Constants";
import { IRuleGroup } from "../../../model/evaluation/RuleGroup";
import { IRuleGroupElementPresentationModel } from "../../../presenter/evaluation/RuleGroupsPresenter";
import Title from "antd/lib/typography/Title";
import BusinessRuleToGroupAssignationForm from "../../components/evaluation/BusinessRuleToGroupAssignationForm";

export interface Props {
  getFieldDecorator: any;
  translate: any;
  rowData?: IRuleGroup;
  codebooks?: any;
  setSelectedBusinessRuleIds?: any;
  setElements?: any;
}
export interface State {
  loading: boolean;
  elements: IRuleGroupElementPresentationModel[];
  onUpdateElement: (...any) => any;
}

export default class RuleGroupForm extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: true,
      elements: [],
      onUpdateElement: () => {}
    };
    this.getAssignedRules = this.getAssignedRules.bind(this);
  }

  async componentDidMount() {
    return this.getAssignedRules();
  }

  async getAssignedRules() {
    const { codebooks, rowData } = this.props;
    if (codebooks) {
      if (typeof codebooks === "function") {
        const data = await codebooks(rowData);
        this.setState({
          loading: false,
          elements: data.get,
          onUpdateElement: data.update
        });
      }
    }
  }

  render() {
    const {
      getFieldDecorator,
      translate,
      rowData,
      codebooks,
      setSelectedBusinessRuleIds,
      setElements
    } = this.props;
    return (
      <Form>
        <Title level={4}>{translate("ruleGroup_form.general_title")}</Title>
        <Form.Item label={translate("ruleGroup_form.name")}>
          {getFieldDecorator(RuleGroupFormFields.Fields.NAME, {
            initialValue: rowData && rowData.name,
            rules: [
              {
                required: true,
                message: translate("ruleGroup_form.required_messages", {
                  field: translate("ruleGroup_form.name")
                })
              }
            ]
          })(<Input maxLength={
            RuleGroupFormFields.VALIDATION_RULES.NAME_MAX_LENGTH
          }/>)}
        </Form.Item>
        <Form.Item label={translate("ruleGroup_form.description")}>
          {getFieldDecorator(RuleGroupFormFields.Fields.DESCRIPTION, {
            initialValue: rowData && rowData.description,
            rules: [
              {
                required: true,
                message: translate("ruleGroup_form.required_messages", {
                  field: translate("ruleGroup_form.description")
                })
              }
            ]
          })(<Input maxLength={
            RuleGroupFormFields.VALIDATION_RULES.DESCRIPTION_MAX_LENGTH}/>)}
        </Form.Item>

        <Form.Item label={translate("ruleGroup_form.weightThreshold")}>
          {getFieldDecorator(RuleGroupFormFields.Fields.WEIGHT_THRESHOLD, {
            initialValue: rowData && rowData.weightThreshold,
            rules: [
              {
                required: true,
                message: translate("ruleGroup_form.required_messages", {
                  field: translate("ruleGroup_form.weightThreshold")
                })
              }
            ]
          })(<Input />)}
        </Form.Item>
        <BusinessRuleToGroupAssignationForm
          translate={translate}
          rowData={rowData}
          codebooks={codebooks}
          setElements={setElements}
          setSelectedBusinessRuleIds={setSelectedBusinessRuleIds}
        />
      </Form>
    );
  }
}
